import React from 'react';
import { cn } from '../../lib/cn';

export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'muted';

const badgeVariants: Record<BadgeVariant, string> = {
  default: 'border border-brand/30 bg-brand/10 text-brand',
  success: 'border border-success/30 bg-success/10 text-success',
  warning: 'border border-warning/30 bg-warning/10 text-warning',
  danger: 'border border-danger/30 bg-danger/10 text-danger',
  muted: 'border border-border bg-surface-alt text-muted',
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export const Badge: React.FC<BadgeProps> = ({ className, variant = 'default', children, ...props }) => (
  <span
    className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', badgeVariants[variant], className)}
    {...props}
  >
    {children}
  </span>
);
